export interface CountdownAnnouncement {
  /** Whether to announce at this second (never every second by default). */
  announce: boolean;
  /** Use `assertive` (interrupt) in the final stretch, otherwise `polite`. */
  assertive: boolean;
}

/**
 * Decide when the screen-reader live region re-announces the countdown.
 * Polite roughly every 15s; assertive at a few marks in the final ~10s.
 * Deliberately NOT every second — that would flood the SR (design §9).
 *
 * Pure + dependency-free so it is unit-testable in isolation (no React / Radix
 * import chain — which keeps it clear of the process-global `mock.module`
 * hazard in the shared `components/` test process; see
 * `.claude/docs/web-unit-test-mocking.md`).
 */
export function getCountdownAnnouncement(
  seconds: number
): CountdownAnnouncement {
  if (seconds <= 0) return { announce: false, assertive: false };
  if (seconds <= 10) {
    const mark =
      seconds === 10 || seconds === 5 || seconds === 3 || seconds === 1;
    return { announce: mark, assertive: true };
  }
  return { announce: seconds % 15 === 0, assertive: false };
}
